import React from "react";
import PropTypes from "prop-types";
import ResourceItem from "../ResourceItem";
import styles from "./ResourceList.module.css";
import { useTranslation } from "react-i18next";

export function ResourceList({ resources }) {
  const {t} =useTranslation();
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}.${day}.${year}`;
  };

  return (
    <div>
      <span className={styles.header}>{t("Membership Resources")}</span>
      <div className={styles.resourceContainer}>
        {resources?.map((resource, index) => {
          const file = resource.files?.[0] || {};

          return (
            <div key={index} className={styles.resourceItem}>
              <ResourceItem
                title={resource.title}
                format={file.format}
                date={formatDate(file.submittedOn)}
                path={file.path}
                downloadPath={file.downloadPath}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

ResourceList.propTypes = {
  resources: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      files: PropTypes.arrayOf(
        PropTypes.shape({
          format: PropTypes.number,
          path: PropTypes.string,
          downloadPath: PropTypes.string,
        })
      ),
      submittedOn: PropTypes.string,
    })
  ),
};
